module.exports = __webpack_public_path__ + "img/prioritas_bosspack_dg_k.89f98d11.png";